module.exports = __webpack_public_path__ + "static/media/services-2.d14f3ec5.jpg";